'use strict';

var GridBookingMatrixSwitchModeButtonController = function GridBookingMatrixSwitchModeButtonController($scope) {
  $scope.cogId = 'grid-service-booking-matrix';
  $scope.cogOptionSet = require('../config/bookingMatrixModeCogOptions.json');
};
GridBookingMatrixSwitchModeButtonController.$inject = ['$scope'];
module.exports = GridBookingMatrixSwitchModeButtonController;